import { Diamond } from "@src/types/DiamondDetail";

export type PriceDetailViewProps = {
  itemDetail?: Diamond;
};

export type JBTProps = {
  logoUrl: string;
  member_type: string;
  info_text: string;
  vendor_name: string;
  mItem: Diamond;
  jbtDetail: any;
  screenName: string;
};

export enum JBTMemberType {
  Listed = "Listed",
  Member = "Member",
}

export enum JBTMemberTypeID {
  notSync = 4,
  enhancedMember = 3,
  regularMember = 2,
  retailMember = 1,
  nonMember = 0,
}
